 <!--
    2019-2-13, AJK, created file
    2019-3-6, AJK, added ability to reset password
    2019-3-6, AJK, updated to use snotify
 -->


<template>
  <div class="login-page container">
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading"></b-loading>
    <div class="columns is-centered">
      <div class="column card-container is-full">
        <div class="control">
          <div class="level-right">
              <button v-on:click="repeatOrder(order.__kptID)" type="email" placeholder="email" class="button is-primary is-pulled-right level-item">Reorder</button>
              <router-link :to="{name: 'dashboard'}" class="level-item">
                <button type="email" placeholder="email" class="button is-primary is-pulled-right">Back</button>
              </router-link>
          </div>
        </div>
        <h1 class="title">Order #{{order.orderNumber}}</h1>
        <div>
            <p> Date: <strong>{{order.date}}</strong></p>
            <p> Total: <strong>{{order.zcnGrandTotal | currency}} </strong></p>
            <p> Tracking Number: <strong>{{order.trackingNumber}}</strong></p>
            <br>
            <div class="level">
              <div class="level-left">
                <div class="level-item address">
                  <p> Shipping Address: <br>
                    <strong>{{order.zctShippingAddressWeb1}}</strong><br>
                    <strong>{{order.zctShippingAddressWeb2}}</strong><br>
                    <strong>{{order.zctShippingAddressWeb3}}</strong><br>
                    <strong>{{order.zctShippingAddressWeb4}}</strong></p>
                  <br>
                  </div>
                  <div class="level-item address">
                  <p> Billing Address: <br>
                    <strong>{{order.zctBillingAddressWeb1}}</strong><br>
                    <strong>{{order.zctBillingAddressWeb2}}</strong><br>
                    <strong>{{order.zctBillingAddressWeb3}}</strong><br>
                    <strong>{{order.zctBillingAddressWeb4}}</strong></p>
                  </div>
                </div>
            </div>
        </div>
        <br>
        <div class="row is-centered">
            <b-table :data="lineItems">
              <template slot-scope="props">
            
                <b-table-column field="productName" label="Product Name">
                  {{ props.row.zctProductWebDisplay}}
                </b-table-column>
                
                <b-table-column field="price" label="Price" numeric>
                  {{ props.row.price | currency}}
                </b-table-column>        
                
                <b-table-column field="qty" label="Quantity" numeric>
                  {{ props.row.qty }}
                </b-table-column>
                
                <b-table-column field="extended" label="Extended Price" numeric>
                  {{ props.row.zcnExtendedPrice | currency}}
                </b-table-column>

                <b-table-column field="AddToCart" label=" " numeric>
                  <button v-on:click="checkQuantity(props.row)" class="button is-primary is-pulled-right" :class="{'disabled': !props.row.zcnCanBeReordered}" >+</button>
                </b-table-column>

              </template>
            </b-table>
            <hr>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import loginAPI from '@/api/LoginAPI.js'
import store from '../store.js'
import { mapMutations, mapState } from 'vuex'
import axios from 'axios'

export default {
    name: 'OrderDetail',
    props: ['usernameProp'],
    data () {
        return {
            username: null,
            password: null,
            hash: null,
            errorMsg: null,
            isLoading: false,
            isFullPage: true,
            notificationDuration: 4000,
            order: {},
            lineItems: [],
            recordID: null
        }
    },

    filters: {
      currency: function(price){
        if ( price !== null && price !== '' && price !== undefined){
          return "$".concat(price.toFixed(2));
        }
      }
    },

    mounted(){
        this.loadData();
    },

    computed:{
    ...mapState([
      'userInfo', 'cart'
     ])
    },
    
    methods: {
        ...mapMutations([
          'setCampaigns', 
          'setEmails',
          'setCampaignsAndEmails',
          'setSelectedCampaign',
          'setCart'
        ]),

        loadData: function() {
        var self = this;
        this.recordID = this.$route.params.id
        axios.post (`proxy.php?/layouts/order-request-lookup/_find`, 
          {query: [
            { 
            recordID : '=' + self.recordID }
            ]
          }
        )
          .then(response=>{
            // console.log(response)
            self.order = response.data.response.data[0].fieldData;
            self.order.zctShippingAddressWeb = 
              axios.post (`proxy.php?/layouts/order-request-line-item-lookup/_find`, 
              {query: [
                { 
                _kftOrderRequestID : '=' + self.order.__kptID }
                ]
              }
              )
              .then(response=>{
                // console.log(response)
                var parse = response.data.response.data;
                
                parse.forEach (function (element) {
                  self.lineItems.push(element.fieldData);
                });
                
              }).catch(error=>{
                console.log(error)
              })
          }).catch(error=>{
            console.log(error)
          })
      },        

      repeatOrder: function(orderID){
        var self = this;
          axios.post (`proxy.php?/layouts/order-request-line-item-lookup/_find`, 
          {query: [
            { 
            _kftOrderRequestID : '=' + orderID }
            ]
          }
          )
          .then(response=>{
            var parse = response.data.response.data;

            //check if line items can be reordered
            var inelligible = []
            parse.forEach (function (element) {
              if (element.fieldData.zcnCanBeReordered != 1  ){
                inelligible.push(element.fieldData.productName)
              }
            });

            //create message for inelligible items
            if (inelligible.length > 0){
              var e
              if (inelligible.length > 1){
                inelligible[inelligible.length-1] = "and " + inelligible[inelligible.length-1]
                e = inelligible.join(", ")
                e = "Items " + e + " are not available to be ordered."
              }else{
                e = inelligible[0] + " is not available to be ordered."
              }
              self.$root.$children[0].$refs.toast.error(e, "Unavailable", {pauseOnHover: true, closeOnClick: true})
              return
            }
            //kill cart
            self.cart.products.splice(0, self.cart.products.length)
            //add elligible items to cart
            var count = 0
            parse.forEach (function (element) {
              if (element.fieldData.zcnCanBeReordered == 1){
                var cartItem = {
                  __kptID: element.fieldData._kftProductID,
                  price: element.fieldData.price,
                  productName: element.fieldData.productName,
                  quantity: element.fieldData.qty,
                  isCustomBlend: false
                }
                self.cart.products.push(cartItem);
                count = count + 1
              }
            });
            if(count>0){
              var message = " product added to cart."
              if (count > 1){
                message = " products added to cart."
              }
              message = count + message
              self.setCart(self.cart)
              self.$root.$children[0].$refs.toast.success(message, "Prepared Cart!")
              self.$router.replace({ name: 'cart'})
            }
            
          }).catch(error=>{
            console.log(error)
          })
      },

      checkQuantity: function(product){
        var self = this;
        if (!product.zcnCanBeReordered){
          var error = product.zctProductWebDisplay + " is not available."
          self.$root.$children[0].$refs.toast.error(error, "Unavailable")
          return 0
        }
        this.$buefy.dialog.prompt({
        message: `How many would you like to add?`,
        inputAttrs: {
            type: 'number',
            placeholder: 'Type quantity',
            value: '1',
            maxlength: 3,
            min: 1
        },
        onConfirm: (value) => self.addToCart(product, value)
        })
      },

      addToCart: function(product, qty) {
        var self = this;
        // console.log(product)
        var found = false;
        for (var i = 0; i < self.cart.products.length; i++){
          if ( self.cart.products[i].__kptID === product._kftProductID){
            self.cart.products[i].quantity = qty;
            found = true
          }
        }
        if (!found){
          if(product.price === ""){
            var productPrice = 0;
          }
          else{
            var productPrice = product.price;
          }
          var cartProduct = {
            __kptID: product._kftProductID,
            price: productPrice,
            productName: product.zctProductWebDisplay,
            quantity: qty,
            isCustomBlend: false
          }
          // console.log(cartProduct)
          self.cart.products.push(cartProduct);
        }
        self.setCart(self.cart)
        self.$root.$children[0].$refs.toast.success("Product Added", "Added to Cart!")
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .card-container {
    padding: rem;
    margin: 0px 20px 20px 20px;
  } 
    .address {
    padding: 0px 20px 0px 0px;
  } 
  .disabled{
    background: lightgrey;
  }
  .disabled:hover{
    background: red;
  }

</style>
